import React, { useState } from "react";
import { urlimage } from "../../utils/config";

const CarteScolaireCard = ({ carte }) => {
  const [imageErrors, setImageErrors] = useState({
    logo: false,
    eleve_photo: false,
    eleve_qr_code: false,
    cachet: false,
  });

  const handleImageError = (imageType) => {
    setImageErrors((prev) => ({ ...prev, [imageType]: true }));
  };

  const getImageUrl = (path) => (path ? `${urlimage}${path}` : null);

  const formatDateFR = (dateStr) => {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    return `${String(date.getDate()).padStart(2, "0")}/${String(
      date.getMonth() + 1
    ).padStart(2, "0")}/${date.getFullYear()}`;
  };

  return (
    <div style={{
      width: "100%",
      maxWidth: "520px",
      aspectRatio: "420 / 240",
      border: "2px solid #004a99",
      borderRadius: 6,
      boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
      backgroundColor: "#fff",
      display: "flex",
      flexDirection: "column",
      fontFamily: "Arial, sans-serif",
      overflow: "hidden",
    }}>

      {/* ── EN-TÊTE : 2 colonnes ── */}
      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "5px 8px",
        flexShrink: 0,
      }}>
        {/* Gauche : Logo + Nom + Slogan + Numéro */}
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          {carte.logo_url && !imageErrors.logo ? (
            <img
              src={getImageUrl(carte.logo_url)}
              alt="Logo"
              crossOrigin="anonymous"
              style={{ width: 48, height: 48, objectFit: "contain", flexShrink: 0 }}
              onError={() => handleImageError("logo")}
            />
          ) : (
            <div style={{
              width: 38, height: 38, flexShrink: 0,
              backgroundColor: "#f0f0f0",
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: 9, color: "#999",
            }}>Logo</div>
          )}
          <div>
            <div style={{ fontSize: 14, fontWeight: "bold", color: "#004a99", lineHeight: "1.2em" }}>
              {carte.nom_ecole || "Nom de l'école"}
            </div>
            <div style={{ fontSize: 11, color: "#555", fontStyle: "italic", lineHeight: "1.3em" }}>
              {carte.description_ecole || ""}
            </div>
            {carte.coordonnees_carte && (
              <div
                style={{
                  fontSize: 11,
                  color: "#333",
                  fontWeight: "bold",
                  lineHeight: "1.3em"
                }}
              >
                {carte.coordonnees_carte}
              </div>
            )}
          </div>
        </div>

        {/* Droite : Pays + Devise + Année */}
        <div style={{ textAlign: "right", flexShrink: 0 }}>
          <div style={{ fontSize: 14, fontWeight: "bold", color: "#004a99", lineHeight: "1.3em" }}>
            {carte.pays || "BURKINA FASO"}
          </div>
          <div style={{ fontSize: 11, color: "#555", fontStyle: "italic", lineHeight: "1.3em" }}>
            {carte.devise_pays || "La Patrie ou la Mort nous Vaincrons"}
          </div>
          <div style={{ fontSize: 11, fontWeight: "bold", color: "#004a99", lineHeight: "1.3em" }}>
            {carte.annee_academique || "-"}
          </div>
        </div>
      </div>

      {/* ── Bandeau CARTE SCOLAIRE ── */}
      <div style={{
        backgroundColor: "#008000",
        color: "#fff",
        fontSize: 14,
        fontWeight: "bold",
        textAlign: "center",
        padding: 3,
        textTransform: "uppercase",
        flexShrink: 0,
      }}>
        CARTE SCOLAIRE
      </div>

      {/* ── Contenu principal ── */}
      <div style={{
        display: "flex",
        padding: 6,
        gap: 8,
        flexGrow: 1,
        overflow: "hidden",
        alignItems: "stretch",
      }}>

        {/* ── Colonne gauche : Photo + Cachet + Signature ── */}
        <div style={{
          flexShrink: 0,
          width: 100,
          display: "flex",
          flexDirection: "column",
          gap: 4,
        }}>
          {/* PHOTO */}
          {carte.eleve_photo_url && !imageErrors.eleve_photo ? (
            <div style={{
              width: 100,
              height: 120,
              border: "2px solid #004a99",
              overflow: "hidden",
              backgroundColor: "white",
              flexShrink: 0,
            }}>
              <img
                src={getImageUrl(carte.eleve_photo_url)}
                alt="photo élève"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </div>
          ) : (
            <Placeholder label="Photo non disponible" />
          )}

          {/* CACHET */}
          <div style={{
            width: 100,
            height: 40,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexShrink: 0,
          }}>
            {carte.cachet_ecole_url && !imageErrors.cachet ? (
              <img
                src={getImageUrl(carte.cachet_ecole_url)}
                alt="Cachet"
                crossOrigin="anonymous"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  imageRendering: "crisp-edges",
                }}
                onError={() => handleImageError("cachet")}
              />
            ) : (
              <div style={{ width: "100%", height: "100%", border: "1px dashed #bbb" }} />
            )}
          </div>

          {/* SIGNATURE */}
          <div style={{
            fontSize: 9,
            textAlign: "center",
            fontWeight: "bold",
            color: "#004a99",
            borderTop: "1px solid #004a99",
            paddingTop: 4,
            paddingBottom: 2,
            whiteSpace: "nowrap",
          }}>
            Signature
          </div>
        </div>

        {/* ── Colonne centre : Infos élève ── */}
        <div style={{
          flex: 1,
          minWidth: 0,
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
        }}>
          <InfoRow label="Matricule"         value={carte.matricule} />
          <InfoRow label="Nom"               value={carte.eleve_nom} />
          <InfoRow label="Prénom(s)"         value={carte.eleve_prenom} />
          <InfoRow label="Date de naissance" value={formatDateFR(carte.date_naissance)} />
          <InfoRow label="Lieu de naissance" value={carte.lieu_naissance} />
          <InfoRow label="Sexe"              value={
            carte.eleve_genre === "M" ? "Masculin"
            : carte.eleve_genre === "F" ? "Féminin" : "-"
          } />
          <InfoRow label="Classe"            value={carte.classe} />
          <InfoRow label="Au besoin"         value={carte.parent_telephone1 || "-"} />
        </div>

        {/* ── Colonne droite : QR Code ── */}
        <div style={{ flexShrink: 0 }}>
          {carte.eleve_qr_code_url && !imageErrors.eleve_qr_code ? (
            <div style={{
              width: 90,
              height: 120,
              border: "2px solid #004a99",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "hidden",
              backgroundColor: "white",
            }}>
              <img
                src={getImageUrl(carte.eleve_qr_code_url)}
                alt="QR code"
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain",
                  display: "block",
                }}
                crossOrigin="anonymous"
                onError={() => handleImageError("eleve_qr_code")}
              />
            </div>
          ) : (
            <Placeholder label="QR Code non disponible" />
          )}
        </div>

      </div>

      {/* ── Pied de carte ── */}
      <div style={{
        fontSize: 8,
        color: "#555",
        fontStyle: "italic",
        textAlign: "center",
        padding: 2,
        borderTop: "1px solid #ccc",
        backgroundColor: "#f1f1f1",
        flexShrink: 0,
        
      }}>
        Validé : {formatDateFR(carte.date_emission)}
      </div>
    </div>
  );
};

const InfoRow = ({ label, value }) => (
  <div style={{
    background: "#e3eaf5",
    margin: "1px 0",
    borderRadius: 3,
    borderLeft: "3px solid #004a99",
    fontWeight: "bold",
    fontSize: "13px",
    padding: 3,
    lineHeight: "1.2em",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  }}>
    {label} : {value || "-"}
  </div>
);

const Placeholder = ({ label }) => (
  <div style={{
    width: 100,
    height: 120,
    border: "2px solid #004a99",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 8,
    color: "#999",
    textAlign: "center",
  }}>
    {label}
  </div>
);

export default CarteScolaireCard;